import { isNalsar } from "Routes/Routes";

/**
 * Display formats for dates, per platform.
 * Add a platform by adding an entry to PLATFORM_OVERRIDES; keys it leaves out keep the default.
 *
 * date-fns tokens (dd/MM/yyyy) except meetingDate, which is used with moment (DD/MM/YYYY).
 * A null/undefined value means "keep the caller's own built-in format".
 */
const DEFAULT_FORMATS = {
  date: "dd MMMM y", // formatDate
  dateTime: "dd MMMM y | h:mm a", // formatDateWithTime
  activityDate: "d MMMM y",
  activityDateTime: "d MMMM y, h:mm a",
  chatDay: "dd-MM-yyyy",
  pickerDateTime: undefined, // @material-ui/pickers default
  meetingDate: null, // each slices/date.js helper keeps its own date part
  calendarDate: null, // FullCalendar defaults
  showMeetingTimeZone: true, // meeting times end with the zone, e.g. "GMT+5:30"
};

const PLATFORM_OVERRIDES = {
  nalsar: {
    date: "dd/MM/yyyy",
    dateTime: "dd/MM/yyyy | h:mm a",
    activityDate: "dd/MM/yyyy",
    activityDateTime: "dd/MM/yyyy, h:mm a",
    chatDay: "dd/MM/yyyy",
    pickerDateTime: "dd/MM/yyyy hh:mm a",
    meetingDate: "DD/MM/YYYY",
    calendarDate: "dd/MM/yyyy",
    showMeetingTimeZone: false,
  },
};

const getPlatform = () => (isNalsar ? "nalsar" : null);

let resolvedFormats;

// Resolved on first call, never at import: Routes/Routes (which defines the platform flags)
// is still mid-evaluation while the modules that import this file are loading.
export function getDateFormats() {
  if (!resolvedFormats) {
    resolvedFormats = {
      ...DEFAULT_FORMATS,
      ...PLATFORM_OVERRIDES[getPlatform()],
    };
  }
  return resolvedFormats;
}
